import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    error: null,
    loading: true,
    environment: 'development',
    browser: '',
    touch: false,
    mobile: false,
    route: '',
    slug: '',
    posts: [],
    isMedia: false,
    isNavigation: false,
    isAudioDescribed: false
  },

  getters: {
    posts: state => state.posts,
    post: state => state.posts.find(({ slug }) => slug === state.slug),
    home: state => state.posts.find(({ slug }) => slug === 'home'),
    more: state => state.posts.find(({ slug }) => slug === 'find-out-more'),
    categories: state => state.posts.filter(({ type }) => type === 'category'),
    subjects: state => state.posts.filter(({ type }) => type === 'subject'),
    getCategoryBySlug: state => slug => state.posts.find(item => item.slug === slug),
    getMediaBySlug: state => slug => state.posts.find(item => item.slug === slug)
  },

  mutations: {
    browser(state, browser) {
      state.browser = browser
    },
    environment(state, environment) {
      state.environment = environment
    },
    isLoading(state, loading) {
      state.loading = loading
    },
    isTouch(state) {
      state.touch = true
    },
    isMobile(state, mobile) {
      state.mobile = mobile
    },
    route(state, route) {
      const slug = route.path.split('/').pop() || '/'
      state.route = route
      state.slug = slug
    },
    isMedia(state, media) {
      state.isMedia = media
    },
    isNavigation(state) {
      state.isNavigation = !state.isNavigation
    },
    toggleAudioDescription(state) {
      state.isAudioDescribed = !state.isAudioDescribed
    },
    populate(state, { posts, error } = {}) {
      state.error = error

      const data = posts
        .map(item => ({
          ...item,
          slug: item.type !== 'category' ? `${item.type}_${item.slug}` : item.slug
        }))

      // Populate(state, posts) {

      //   const data = posts
      //     .map(item => ({
      //       ...item,
      //       slug: item.type !== 'category' ? `${item.type}_${item.slug}` : item.slug
      //     }))

      const all = data.filter(({ type }) => type !== 'category' && type !== 'subject' && type !== 'group')

      const subjects = data.filter(({ type }) => type === 'subject')
        .map((item) => {
          const children = item.children ? item.children : []
          return {
            ...item,
            children: [ item, ...children.map(o => data.find(f => f.id === o)) ]
          }
        })

      const group = data.filter(({ type }) => type === 'group')
        .map((item) => {
          const children = item.children ? item.children : [ 4000 ]
          return {
            ...item,
            children: children.map(o => data.find(f => f.id === o))
          }
        })

      const categories = data.filter(({ type }) => type === 'category')
        .map((item) => {
          const children = item.children ? item.children : []
          return {
            ...item,
            children: children.map(o => data.find(f => f.id === o))
          }
        })

      state.posts = [ ...all, ...categories, ...subjects, ...group ]
    }
  },

  actions: {}
})

export default store
